import { getTheme } from '@fluentui/react';
import { merge } from '@bingads-webui-universal/primitive-utilities';

const { palette } = getTheme();

export const getStepBaseLayoutFooterStyles = (styleOverrides = {}) => () => merge({
  footerContainer: {
    clear: 'both',
    borderTop: `1px solid ${palette.neutralLight}`,
    paddingLeft: '24px',
    paddingTop: '16px',
    paddingBottom: '16px',
  },
  previousButton: {
    marginRight: '8px',
  },
  previousButtonOnTheRightOfNext: {
    marginLeft: '12px',
  },
  cancelButton: {
    marginLeft: '33px',
  },
  skippingLink: {
    marginLeft: '41px',
    textDecoration: 'underline',
  },
}, styleOverrides);

export const baseLayoutFooterStyles = {
  stepProgress: {
    root: {
      color: palette.neutralPrimary,
      paddingTop: 5,
      paddingLeft: 16,
    },
  },
};
